import oidc from 'oidc-client';
import { useContext } from 'react';
import startupConfig from '../config/startupConfig';
import contexts from '../contexts';

function getInternalUserRoles() {
  const config = startupConfig.get();
  if (!config || !config.internalRoles) {
    return {};
  }
  return config.internalRoles;
}

async function getCurrentUser() {
  const config = startupConfig.get();
  if (!config || !config.userManagerConfiguration) {
    return {
      relationshipManager: '',
      brokerRelationshipManager: '',
      shiftTeam: '',
    };
  }
  const user = await new oidc.UserManager(config.userManagerConfiguration).getUser();
  return user;
}

//Don't use this method in React components and actions,
//instead use the user in LoginContext.
async function hasInternalUserLoggedIn() {
  const user = await getCurrentUser();
  if (user) {
    return true;
  }
  return false;
}

async function isCurrentUserInRole(user, role) {
  if (!user || !user.profile || !user.profile.role) {
    return false;
  }

  return user.profile.role.includes(role);
}

async function isCurrentUserInShiftTeam(user) {
  const roles = getInternalUserRoles();
  const isInRole = await isCurrentUserInRole(user, roles.shiftTeam);
  return isInRole;
}

async function isCurrentUserRelationshipManager(user) {
  const roles = getInternalUserRoles();
  const isInRole = await isCurrentUserInRole(user, roles.relationshipManager);
  return isInRole;
}

async function isCurrentUserBrokerRelationshipManager(user) {
  const roles = getInternalUserRoles();
  const isInRole = await isCurrentUserInRole(user, roles.brokerRelationshipManager);
  return isInRole;
}

const useLoggedInUserContext = () => {
  const { LoginContext } = contexts;
  const { user } = useContext(LoginContext);
  return user;
};

const identityUtils = {
  isCurrentUserBrokerRelationshipManager,
  isCurrentUserRelationshipManager,
  isCurrentUserInShiftTeam,
  useLoggedInUserContext,
  hasInternalUserLoggedIn,
  getCurrentUser,
};

export default identityUtils;
